import { DataTableScope } from '../../../shared/components/DataTable'
import { getDetailPanelPath } from '../../../shared/hooks/useTableDetailPanel'
import { NO_VALUE_LABEL, toListLabel, toYesNo } from '../../../shared/utils/displayValue'
import { formatQuarterUTC } from '../../../shared/utils/resolveActivityTimelineDates'
import { ActivityColumnId, ActivityRow } from './ActivityTable.types'

export const UNKNOWN_VALUE_LABEL = 'Unknown'

export const EVIDENCE_TACTICS_TABLE_SCOPE: DataTableScope = { id: 'evidenceTacticsTable', keptPer: 'roadmap' }

export const IDEATION_TABLE_SCOPE: DataTableScope = { id: 'ideationTable', keptPer: 'roadmap' }

export const ACTIVITY_IMPORTS_TABLE_SCOPE: DataTableScope = { id: 'activityImportsTable', keptPer: 'roadmap' }

export const ACTIVITY_VALUE_MESSAGES_TABLE_SCOPE: DataTableScope = { id: 'activityValueMessages', keptPer: 'roadmap' }

export const ACTIVITY_STRATEGIC_IMPERATIVES_TABLE_SCOPE: DataTableScope = {
    id: 'activityStrategicImperatives',
    keptPer: 'roadmap',
}

export const DEFAULT_LINKED_ACTIVITY_COLUMN_IDS: ReadonlySet<ActivityColumnId> = new Set([
    'title',
    'status',
    'activityTimeline',
    'type',
    'function',
])

export const getActivityPath = ({ _id }: ActivityRow) => getDetailPanelPath('/activities', _id)

export const getCompletionDateLabel = ({ completionDate, isPlannedCompletionDate }: ActivityRow) => {
    if (!completionDate) return NO_VALUE_LABEL

    const label =
        isPlannedCompletionDate || completionDate.getUTCMinutes() === 1
            ? completionDate.toLocaleDateString('en-US', { timeZone: 'UTC' })
            : formatQuarterUTC(completionDate)

    return isPlannedCompletionDate ? `${label} (Planned)` : label
}

export const getActivityFunction = (activity: ActivityRow) => activity.function || UNKNOWN_VALUE_LABEL

export const getActivityCategory = (activity: ActivityRow) => activity.category || UNKNOWN_VALUE_LABEL

export const getActivityTherapeuticArea = (activity: ActivityRow) => activity.therapeuticArea || UNKNOWN_VALUE_LABEL

export const getActivitySource = (activity: ActivityRow) => activity.source || 'Atlas'

export const getBudgetLabel = (amount: number | null) =>
    amount === null
        ? NO_VALUE_LABEL
        : amount.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })

export const ALWAYS_VISIBLE_ACTIVITY_COLUMN_IDS: ReadonlySet<string> = new Set<ActivityColumnId>(['title'])

export const DEFAULT_ACTIVITY_COLUMN_IDS: ReadonlySet<ActivityColumnId> = new Set([
    'title',
    'status',
    'activityTimeline',
    'type',
    'function',
    'linkedValueMessageCount',
])

export const DEFAULT_IDEATION_COLUMN_IDS: ReadonlySet<ActivityColumnId> = new Set([
    'title',
    'status',
    'activityTimeline',
    'type',
    'function',
    'corporateOrRnDGoal',
    'linkedValueMessageCount',
    'linkedStrategicImperativeCount',
    'linkedTppCellCount',
    'funded',
    'budget',
])

export const DEFAULT_ACTIVITY_IMPORT_COLUMN_IDS: ReadonlySet<ActivityColumnId> = new Set([
    'title',
    'source',
    'studyNumber',
    'status',
    'function',
    'therapeuticArea',
    'indication',
    'genericName',
])
